var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReddit = function SvgReddit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 15.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E5E5E5",
    rx: 15.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h24v24H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4500",
    d: "M16 26c-5.523 0-10-4.477-10-10S10.477 6 16 6s10 4.477 10 10-4.477 10-10 10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.33 16a1.463 1.463 0 0 1 2.472-1.001 7.1 7.1 0 0 1 3.85-1.231l-.649-3.12-2.14.45a1 1 0 1 1-.132-.611l2.451-.49a.31.31 0 0 1 .37.236v.005l.74 3.47a7.16 7.16 0 0 1 3.9 1.23 1.46 1.46 0 1 1 1.605 2.392q.015.22 0 .44c0 2.24-2.61 4.062-5.83 4.062-3.218 0-5.828-1.82-5.828-4.062a3 3 0 0 1 0-.44A1.46 1.46 0 0 1 9.331 16m10 1.002c0-.552-.45-1.002-1-1.002-.553 0-1.003.45-1.003 1.002s.45 1.002 1.002 1.002a1.005 1.005 0 0 0 1.002-1.002m-5.808 2.75a3.84 3.84 0 0 0 2.47.77c.89.037 1.76-.236 2.471-.77a.27.27 0 0 0-.38-.38 3.27 3.27 0 0 1-2.08.628 3.3 3.3 0 0 1-2.09-.61.28.28 0 0 0-.39.401zm.18-1.713c.551 0 1.001-.45 1.001-1.002s-.45-1.002-1.002-1.002-1.002.45-1.002 1.002a1 1 0 0 0 .96 1.039h.05z"
  })));
};
export default SvgReddit;